export default __webpack_public_path__ + "static/media/eth-logo.71a07149.svg";